var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Endorsements")]),_c('div',{staticClass:"grid-container"},_vm._l((_vm.items),function(item){return _c('Endorsement',{key:item.name,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }